import { h } from 'vue';
import { SettingsEntry } from '../settings-entry';
import FormToggle from '@frontend/components/FormToggle';
import app from '@frontend/application-container';
import icon from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/Top/search/tooltips.svg';
import { img } from '@phi/components';

export const TooltipsIcon = icon;

export function ShowHideTooltips() {
    return SettingsEntry(
        'Tooltips',

        'Show help when buttons are hovered. (Unavailable in Phi Touch)',

        img(icon, 'Show/hide tooltips'),

        h(FormToggle, {
            value: app.settings.tooltips,
            'onUpdate:value': x => app.settings.tooltips = x,
        })
    );
}
